import Tooltip from '@ui/tooltip';
import { type FC } from 'react';
import styles from './index.module.scss';
import needIcon from '@assets/images/icons/need.svg';
import securityIcon from '@assets/images/icons/security.svg';
import { Link } from 'react-router-dom';
import { config } from '@config';
const NeedHelp: FC = () => {
  const securityUrl =
    config.sui_network === 'mainnet'
      ? 'https://turbos.finance/#/security'
      : 'http://testwebsite.turbos.s3-website-us-east-1.amazonaws.com/#/security';

  return (
    <>
      <Tooltip
        overlay={
          <div className={styles.need_con}>
            If you have any questions, please contact the turbos team for help.
            <Link to="https://t.me/sydneywolfey" target={'_blank'}>
              Telegram1
            </Link>
            ,
            <Link to="https://t.me/allisonxyz" target={'_blank'}>
              Telegram2
            </Link>
          </div>
        }
        placement="bottom"
      >
        <div className={`${styles.need}`}>
          <img src={needIcon} />
          Need Help?
        </div>
      </Tooltip>

      <Link to={securityUrl} target={'_blank'} className={`${styles.security}`}>
        <img src={securityIcon} />
        Security
      </Link>
    </>
  );
};

export default NeedHelp;
